import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import { navigationService } from '@/content/services/navigation.service'

export const getSearchParameterByName = (name: string) => {
    const location = navigationService.getLocation()
    if (!location) {
        getLogger('GetSearchParameterByName').value.warn('Attempted to get search parameter without location', { name })
        return undefined
    }
    const searchParams = new URLSearchParams(location.search)
    return searchParams.get(name) ?? undefined
}
